

export const GET_REPLANDETAILS = 'GET_REPLANDETAILS';
export const SAVE_PERSONAL_DETAILS = 'SAVE_PERSONAL_DETAILS';
export const SAVE_HOME_DETAILS ='SAVE_HOME_DETAILS';
export const SAVE_WORK_DETAILS ='SAVE_WORK_DETAILS';
export const SAVE_REIMBURSEMENT_DETAILS ='SAVE_REIMBURSEMENT_DETAILS';
export const SAVE_ALTERNATE_DETAILS ='SAVE_ALTERNATE_DETAILS';
export const UPDATE_REIMBURSEMENT_DETAILS ='UPDATE_REIMBURSEMENT_DETAILS';
export const SAVE_HOUSING_DETAILS = 'SAVE_HOUSING_DETAILS';
export const SAVE_INVENTORY_NAME = 'SAVE_INVENTORY_NAME';
export const SET_HOME_LOADING = 'SET_HOME_LOADING';
export const SET_WORK_LOADING = 'SET_WORK_LOADING';
export const SET_HOUSING_LOADING = 'SET_HOUSING_LOADING';

export function getRePlanDetails(rePlanDetails){
    return{
        type:GET_REPLANDETAILS,
        cases:rePlanDetails
    }
}
export function savePersonalDetails(data){
    return{
        type:SAVE_PERSONAL_DETAILS,
        data:data
    }
}
export function saveHomeDetails(data){
    return{
        type:SAVE_HOME_DETAILS,
        data:data
    }
}
export function saveWorkDetails(data){
    return{
        type:SAVE_WORK_DETAILS,
        data:data
    }
}
export function saveAlternateDetails(data){
    return{
        type:SAVE_ALTERNATE_DETAILS,
        data:data
    }
}
export function saveReimbursementDetails(data){
    return{
        type:SAVE_REIMBURSEMENT_DETAILS,
        data:data
    }
}
export function updateReimbursementDetails(data){
    return{
        type:UPDATE_REIMBURSEMENT_DETAILS,
        data:data
    }
}
export function saveHousingDetails(housingDetails){
    return{
        type:SAVE_HOUSING_DETAILS,
        data:housingDetails
    }
}
export function saveInventoryName(name){
    return{
        type:SAVE_INVENTORY_NAME,
        data:name
    }
}
export function setHomeLoading(homeLoading) {
    return {
        type: SET_HOME_LOADING,
        homeLoading: homeLoading
    }
}
export function setWorkLoading(workLoading) {
    return {
        type: SET_WORK_LOADING,
        workLoading: workLoading
    }
}
export function setHousingLoading(housingLoading) {
    return {
        type: SET_HOUSING_LOADING,
        housingLoading: housingLoading
    }
}